const nivoCustomTheme = {
  background: 'transparent',
  fontFamily: '"Inter", sans-serif',
  fontSize: 12,
  textColor: '#6B7280',
  axis: {
    domain: {
      line: { stroke: '#F0F0F0', strokeWidth: 1 },
    },
    ticks: {
      line: { stroke: '#F0F0F0', strokeWidth: 1 },
      text: { fill: '#6B7280', fontSize: 11, fontFamily: '"Inter", sans-serif' },
    },
    legend: {
      text: { fill: '#3D4451', fontSize: 12, fontWeight: 600, fontFamily: '"Inter", sans-serif' },
    },
  },
  grid: {
    line: { stroke: '#F0F0F0', strokeWidth: 1 },
  },
  legends: {
    text: { fill: '#3D4451', fontSize: 11, fontFamily: '"Inter", sans-serif' },
  },
  tooltip: {
    container: {
      background: '#FFFFFF',
      color: '#3D4451',
      fontSize: 12,
      fontFamily: '"Inter", sans-serif',
      borderRadius: 8,
      boxShadow: '0 4px 20px rgba(38, 97, 156, 0.12)',
      border: '1px solid #F0F0F0',
      padding: '8px 12px',
    },
  },
  labels: {
    text: {
      fill: '#FFFFFF',
      fontSize: 11,
      fontWeight: 600,
      fontFamily: '"Inter", sans-serif',
    },
  },
  dots: {
    text: { fill: '#3D4451', fontSize: 11 },
  },
  crosshair: {
    line: { stroke: '#3B82F6', strokeWidth: 1, strokeOpacity: 0.5 },
  },
};

export default nivoCustomTheme;
